import { css, FlattenSimpleInterpolation } from 'styled-components'

import { palette } from '_styles/variables'

import { PositionGetter, Placement } from './types'

export const getTooltipPositions: PositionGetter = ({
  x,
  y,
  placement = 'top',
}) => {
  const top = y ?? 0
  const left = x ?? 0

  const ttDistance = 16

  switch (placement) {
    case 'bottom':
    case 'bottom-start':
    case 'bottom-end':
      return {
        top: top + ttDistance,
        left,
      }
    case 'right':
    case 'right-start':
    case 'right-end':
      return {
        top,
        left: left + ttDistance,
      }
    case 'left':
    case 'left-start':
    case 'left-end':
      return {
        top,
        left: left - ttDistance,
      }
    default:
      return {
        top: top - ttDistance,
        left,
      }
  }
}

export const getArrowPositions: PositionGetter = ({ placement }) => {
  switch (placement) {
    case 'top':
      return {
        top: '100%',
        left: '50%',
      }
    case 'top-end':
      return {
        top: '100%',
        left: '60%',
      }
    case 'top-start':
      return {
        top: '100%',
        left: '25%',
      }
    case 'right':
    case 'right-start':
    case 'right-end':
      return {
        top: 'calc(50% - 0.375rem)',
        right: '100%',
      }
    case 'bottom':
      return {
        bottom: '100%',
        left: '50%',
      }
    case 'bottom-end':
      return {
        bottom: '100%',
        left: '75%',
      }

    case 'bottom-start':
      return {
        bottom: '100%',
        left: '25%',
      }
    default:
      return {
        top: 'calc(50% - 0.375rem)',
        left: '100%',
      }
  }
}

const getPositionString = (pos: number | string): string => {
  if (typeof pos === 'string') return pos
  return `${pos}px`
}

export const positionToCss =
  (func: PositionGetter): PositionGetter<FlattenSimpleInterpolation> =>
  args => {
    const { top, left, right, bottom } = func(args)

    return css`
      ${top !== undefined && `top: ${getPositionString(top)};`}
      ${right !== undefined && `right: ${getPositionString(right)};`}
      ${bottom !== undefined && `bottom: ${getPositionString(bottom)};`}
      ${left !== undefined && `left: ${getPositionString(left)};`}
    `
  }

export const getArrowShape = ({ placement }: { placement: Placement }) => {
  const common = css`
    content: '';
    position: absolute;
    border: 15px solid transparent;
  `

  const horizontal = css`
    border-right-width: 6px;
    border-left-width: 6px;
  `

  const vertical = css`
    border-top-width: 6px;
    border-bottom-width: 6px;
  `
  switch (placement) {
    case 'right':
    case 'right-start':
    case 'right-end':
      return css`
        ${common}
        ${vertical}
        border-right: 10px solid ${palette.brand.teal};
      `
    case 'bottom':
    case 'bottom-start':
    case 'bottom-end':
      return css`
        ${common}
        ${horizontal}
        border-bottom: 10px solid ${palette.brand.teal};
      `
    case 'left':
    case 'left-start':
    case 'left-end':
      return css`
        ${common}
        ${vertical}
        border-left: 10px solid ${palette.brand.teal};
      `
    default:
      return css`
        ${common}
        ${horizontal}
        border-top: 10px solid ${palette.brand.teal};
      `
  }
}
